import { SEARCH_LEAD_COUNTY_REQUEST, SEARCH_LEAD_COUNTY_REQUEST_SUCCESS, SEARCH_LEAD_COUNTY_REQUEST_FAILURE } from '../constants/search_lead_county.constants';

export const searchLeadCountyRequest = searchText => ({ type: SEARCH_LEAD_COUNTY_REQUEST, searchText });
export const searchLeadCountyRequestSuccess = payload => ({ type: SEARCH_LEAD_COUNTY_REQUEST_SUCCESS, payload });
export const searchLeadCountyRequestFailure = error => ({ type: SEARCH_LEAD_COUNTY_REQUEST_FAILURE, error });



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_create/redux/actions/search_lead_county.actions.js